import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const e=t("brasil",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#009B3A" />
            <path
                d="M11.9999 5.40332L21.5859 12.4864L11.9999 19.5647L2.36719 12.4864L11.9999 5.40332Z"
                fill="#FEDF00" />
            <path
                d="M12.0002 16.2611C14.0775 16.2611 15.7616 14.5771 15.7616 12.4997C15.7616 10.4223 14.0775 8.73828 12.0002 8.73828C9.92281 8.73828 8.23877 10.4223 8.23877 12.4997C8.23877 14.5771 9.92281 16.2611 12.0002 16.2611Z"
                fill="white" />
            <path
                d="M10.1006 12.2519C9.45034 12.2519 8.81876 12.3501 8.22461 12.5326C8.25268 14.5864 9.92286 16.2425 11.9813 16.2425C13.2538 16.2425 14.3813 15.6063 15.0597 14.6379C13.8948 13.1876 12.103 12.2519 10.1006 12.2519ZM15.6679 13.2016C15.71 12.9677 15.7381 12.7291 15.7381 12.4811C15.7381 10.4039 14.0538 8.71973 11.9767 8.71973C10.4281 8.71973 9.09946 9.66008 8.51935 10.9934C9.02929 10.8905 9.55326 10.8343 10.0913 10.8343C12.2807 10.839 14.255 11.7466 15.6679 13.2016Z"
                fill="#002776" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40007"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40007)">
            <g clip-path="url(#clip0_4915_40007)">
                <path
                    d="M-5.96484 0.492188H30.0352V24.4922H-5.96484V0.492188Z"
                    fill="#009B3A" />
                <path
                    d="M12.0351 1.84668L26.414 12.4712L12.0351 23.0888L-2.41406 12.4712L12.0351 1.84668Z"
                    fill="#FEDF00" />
                <path
                    d="M12.0352 18.1338C15.1512 18.1338 17.6773 15.6078 17.6773 12.4917C17.6773 9.37567 15.1512 6.84961 12.0352 6.84961C8.91912 6.84961 6.39307 9.37567 6.39307 12.4917C6.39307 15.6078 8.91912 18.1338 12.0352 18.1338Z"
                    fill="white" />
                <path
                    d="M9.1861 12.1205C8.21067 12.1205 7.2633 12.2679 6.37207 12.5416C6.41418 15.6223 8.91944 18.1065 12.0072 18.1065C13.9159 18.1065 15.6072 17.1521 16.6247 15.6995C14.8773 13.524 12.1896 12.1205 9.1861 12.1205ZM17.537 13.5451C17.6001 13.1942 17.6422 12.8363 17.6422 12.4644C17.6422 9.34858 15.1159 6.82227 12.0001 6.82227C9.67733 6.82227 7.68435 8.23279 6.81418 10.2328C7.57909 10.0784 8.36505 9.9942 9.17207 9.9942C12.4563 10.0012 15.4177 11.3626 17.537 13.5451Z"
                    fill="#002776" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40007">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.492188)" />
            </clipPath>
        </defs>
    </svg>
`,p=t("brasil_rounded",l),r=t("BRL",l);export{r as BRL,e as Brasil,p as BrasilRounded};
